import React, {Component, forwardRef, useImperativeHandle, useEffect} from 'react';
import { Button } from 'react-bootstrap';

import DimensionCtrl from '../charts/DimensionCtrl';
import MeasureCtrl from '../charts/MeasureCtrl';
import MeasurePropertyCtrl from "../charts/MeasurePropertyCtrl";
import FilterCtrl from '../charts/FilterCtrl';
import { isEntity, isProperty } from '../../data/utils';
import { Entity } from '../../data/Definition';
import { IDimension, IFilter, IMeasure } from '../../data/Query';

const configVersion = '2';

interface IMapDwFormState {
    dimension: IDimension | null,
    measure: IMeasure | null,
    filters: IFilter[]
};

class MapDwForm extends Component<any, IMapDwFormState>  {
    constructor(props: any) {
        super(props);
        this.state = {
            dimension: null,        
            measure: null,
            filters: []
        };   
        console.log("020122 props", props);
    }

    componentDidMount() {
        console.log("this.props.queryConfig", this.props.queryConfig)
        console.log("020122 this.props", this.props)
        console.log("020122 this.state", this.state)
        if(this.props.queryConfig) {
            this.initFromConfig(this.props.queryConfig);
        }
    }

    initFromConfig(config: any) {
        console.log("map dw config", config)

        let dimension: IDimension = {
            source: {
                item: config.dimension && config.dimension.source && config.dimension.source.item ? this.getItemFromDefinition(config.dimension.source.item) : null,
                sub: config.dimension && config.dimension.source ? config.dimension.source.sub : null
            },
            bin: config.dimension && config.dimension.bin
        };

        let measure: IMeasure = {
            source: {
                item: config.measure && config.measure.source ? this.getItemFromDefinition(config.measure.source.item) : null,
                sub: config.measure && config.measure.source ? config.measure.source.sub : null
            },
            aggregation: config.measure && config.measure.aggregation
        };

        let filters = config.filters.map((filter:IFilter) : IFilter => {
            const f: IFilter = {
                source: {
                    item: this.getItemFromDefinition(filter.source.item),
                    sub: filter.source.sub
                },
                operation: filter.operation,
                value: filter.value
            };

            return f;
        });

        this.setState({
            dimension: dimension,
            measure: measure,
            filters: filters
        });
    }

    saveToConfig(e: any) {
        e.preventDefault();

        let config = {
            version: configVersion,
            definitionId: this.props.definition.id,
            entity: this.props.definition.name,
            dimension: this.state.dimension,
            measure: this.state.measure,
            filters: this.state.filters, 
            feature: this.props.definition.feature
        };
        console.log("122221 config", config)
        console.log("122221 this.props.definition", this.props.definition)
        // pass back to caller.
        console.log("122221 saveToConfig() > map", config); 
        
        if(this.props.saveConfig) {
            this.props.saveConfig(config);
        }
    }

    applyConfig() {
        let config = {
            version: configVersion,
            definitionId: this.props.definition.id,
            entity: this.props.definition.name,
            dimension: this.state.dimension,
            measure: this.state.measure,
            filters: this.state.filters, 
            feature: this.props.definition.feature
        };
        console.log("122221 config", config)
        console.log("122221 this.props.definition", this.props.definition)
        // pass back to caller.
        console.log("122221 saveToConfig() > map", config); 
        
        if(this.props.saveConfig) {
            this.props.saveConfig(config);
        }
    }

    validate() : boolean {
        return true;
    }

    getItemFromDefinition(item:any) {   
        let defItem = item;

        // main entity.
        if (item){
            if(item.name === this.props.definition.name) {
                return this.props.definition;
            }

            if(isEntity(item)) {
                defItem = this.props.definition.entity.find((i:any) => {
                    return i.name === item.name;
                });
            } else if(isProperty(item)) {
                defItem = this.props.definition.property.find((i:any) => {
                    return i.name === item.name;
                });
            }
        }

        return defItem;
    }

    render() {
        var renderDimensionPerDefinition = (_def_id:any) => {
            /*if  (this.props.definition.entity.filter((item:Entity) => item.spatial).length === 0){
                return '';
            }else{*/
                return <DimensionCtrl 
                    definition={this.props.definition} 
                    config={this.state.dimension} 
                    entities={this.props.definition.entity.filter((item:Entity) => item.spatial)} // <-- Mutation to examine 
                    includeRoot={true}
                    propertyTypes={[]}
                    onUpdate={(e:any) => this.onDimenstionUpdate(e)}>
                </DimensionCtrl>;
            //}
        }

        var renderMeasurePerDefinition = (_def_id:any) => {
            //console.log("_def_id", _def_id);
            //console.log("this.props.definition", this.props.definition);
            if (this.props.definition.feature === "multipolygon"){
                return  (
                    <MeasurePropertyCtrl 
                        title='Measure (value to map)'
                        definition={this.props.definition} 
                        measure={this.state.measure} 
                        onUpdate={(e:any) => this.onMeasureUpdate(e)}/>
                );
            }
            if (this.props.definition.entity.filter((item:Entity) => item.spatial).length === 0){
                //console.log("RETURN NOTHING");
                return '';
            }else{
                if ((_def_id === 1)||(_def_id === 3)||(_def_id === 4)) { // Liquid Freight
                    return (
                        <MeasureCtrl 
                            definition={this.props.definition} 
                            measure={this.state.measure} 
                            onUpdate={(e:any) => this.onMeasureUpdate(e)}>
                        </MeasureCtrl>
                    )
                } else { // LandScan 
                    return  (
                        <MeasurePropertyCtrl 
                            title='Measure (value to map)'
                            definition={this.props.definition} 
                            measure={this.state.measure} 
                            onUpdate={(e:any) => this.onMeasureUpdate(e)}/>
                    );
                }
            }
        }

        return (
            <div>
                {renderDimensionPerDefinition(this.props.definition.id)}  
                {renderMeasurePerDefinition(this.props.definition.id)}

                <FilterCtrl 
                    definition={this.props.definition} 
                    config={this.state.filters} 
                    onUpdate={(e:any) => this.onFiltersUpdate(e)}>
                </FilterCtrl>

               {/* <Button 
                    variant="primary" 
                    type="submit" 
                    disabled={!this.validate()}
                    onClick={this.saveToConfig.bind(this)}>
                    Apply DW
                </Button>*/}
            </div>
        );
    }

    onDimenstionUpdate(config:any) {
        console.log("onDimenstionUpdate() config", config)
        this.setState({
            dimension: config
        })
    }

    onMeasureUpdate(config:any) {
        console.log("onMeasureUpdate() config", config)
        this.setState({
            measure: config
        })
    }

    onFiltersUpdate(config:any) {
        this.setState({
            filters: config
        })
    }
}

export default MapDwForm;